import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { getAppInstance } from '@helios/auth-firebase-web';

/**
 * Upload a form template image to Firebase Storage.
 * Path: orgs/{orgId}/form-templates/{formDefinitionId}/{pageId}/{filename}
 */
export async function uploadFormTemplateImage(params: {
  orgId: string;
  formDefinitionId: string;
  pageId: string;
  file: File;
}): Promise<{ downloadUrl: string; storagePath: string }> {
  const { orgId, formDefinitionId, pageId, file } = params;

  const storagePath = `orgs/${orgId}/form-templates/${formDefinitionId}/${pageId}/${file.name}`;
  const storage = getStorage(getAppInstance());
  const storageRef = ref(storage, storagePath);

  await uploadBytes(storageRef, file, {
    contentType: file.type || 'application/octet-stream',
  });

  const downloadUrl = await getDownloadURL(storageRef);

  return { downloadUrl, storagePath };
}
